// Reactive HUD widgets (UI framework A, Set 12.2): a plugin DECLARES a readout with plugin.hud and
// pushes its value per player with engine.setStat; the client renders it. This pure module turns the
// declared specs (which ride `welcome`) plus the local player's hud stats (from the snapshot) into a
// draw list — no canvas, so it's testable. drawWidgets() in renderer.js paints the result.

// widgets: [{ name, spec:{ kind, label, max, color, low, lowAt, icon } }]  — declared, from welcome
// stats:   { <name>: value, ... }                                          — local player's hud, snapshot
export function resolveWidgets(widgets, stats) {
    if (!widgets || !widgets.length || !stats) return [];
    const out = [];
    for (const w of widgets) {
        const v = stats[w.name];
        if (v == null) continue; // no value pushed yet — don't draw an empty widget
        const s = w.spec || {};
        const label = (s.label || w.name).toUpperCase();
        if ((s.kind || "bar") === "bar") {
            const max = s.max || 100;
            const frac = Math.max(0, Math.min(1, v / max));
            const color = s.low && frac <= (s.lowAt ?? 0.3) ? s.low : s.color || "#7bd88f";
            out.push({ kind: "bar", name: w.name, label, value: v, max, frac, color, icon: s.icon || null });
        } else {
            out.push({ kind: "counter", name: w.name, label, value: v, color: s.color || "#cdd6ee", icon: s.icon || null });
        }
    }
    return out;
}
